import { GeoLocationEntity, GroupDetailsDto } from '@smatchy/sdk';
import { GroupContentStateModel } from './group-content.state';

export class DeleteGroupAction {
  static readonly type = '[EditGroup] DeleteGroupAction';
}

export class EditGroupAction {
  static readonly type = '[EditGroup] EditGroupAction';
}
export class PopulateEditGroupAction {
  static readonly type = '[EditGroup] PopulateEditGroupAction';

  /*
   * `GroupContentStateModel` and not `GroupDetailsDto`: both callers hand the
   * group held in the content state, which also describes the moment before a
   * group is loaded, so its sport and its location may be null. The generated
   * DTO describes a group that exists and declares neither as absent.
   */
  constructor(public payload: { group: GroupContentStateModel }) {}
}

export class SetTitleEditGroupAction {
  static readonly type = '[EditGroup] SetTitleEditGroupAction';

  constructor(public payload: string) {}
}

export class SetBackgroundImgEditGroupAction {
  static readonly type = '[EditGroup] SetBackgroundImgEditGroupAction';

  constructor(public payload: string) {}
}

/** The group's own square mark. An empty payload removes it. */
export class SetLogoUrlEditGroupAction {
  static readonly type = '[EditGroup] SetLogoUrlEditGroupAction';

  constructor(public payload: string) {}
}

export class SetGroupDescriptionEditGroupAction {
  static readonly type = '[EditGroup] SetGroupDescriptionEditGroupAction';

  constructor(public payload: string) {}
}

export class SetWebsiteUrlEditGroupAction {
  static readonly type = '[EditGroup] SetWebsiteUrlEditGroupAction';

  constructor(public payload: string) {}
}

export class SetGroupLocationEditGroupAction {
  static readonly type = '[EditGroup] SetGroupLocationEditGroupAction';

  constructor(public payload: GeoLocationEntity) {}
}

export class SetSportEditGroupAction {
  static readonly type = '[EditGroup] SetSportEditGroupAction';

  /** SMA-99: `sportIds` optional, so the single-sport callers keep meaning one. */
  constructor(public payload: { sportId: string; sportIds?: string[] }) {}
}

export class SetWhoCanPublishEditGroupAction {
  static readonly type = '[EditGroup] SetWhoCanPublishEditGroupAction';

  constructor(public payload: { whoCanPublish: 'allMembers' | 'onlyAdmin' }) {}
}

export class SetPrivacyEditGroupAction {
  static readonly type = '[EditGroup] SetPrivacyEditGroupAction';

  constructor(public payload: { privacy: 'public' | 'hidden' | 'private' }) {}
}

export class SetActivitySharingEditGroupAction {
  static readonly type = '[EditGroup] SetActivitySharingEditGroupAction';

  constructor(public payload: { activitySharing: boolean }) {}
}

export class SetHandiFriendlyEditGroupAction {
  static readonly type = '[EditGroup] SetHandiFriendlyEditGroupAction';

  constructor(public payload: { handiFriendly: boolean }) {}
}
